export default __webpack_public_path__ + "static/media/errorIcon.f2fae777.png";